import QRCode from 'qrcode';

/**
 * QR-Code der Aktivierung als SVG-Text – mit der vorhandenen Abhängigkeit `qrcode` (wie der
 * RKSV-QR in `Belegansicht.tsx`), keine neue Abhängigkeit. Fehlerkorrektur M.
 *
 * Der Inhalt kommt immer aus der Startantwort des Servers (`pruefeQrInhalt`), nie fest im Code.
 */
export async function aktivierungsQrSvg(inhalt: string): Promise<string | null> {
  if (inhalt === '') {
    return null;
  }
  return QRCode.toString(inhalt, { type: 'svg', errorCorrectionLevel: 'M', margin: 1 });
}
